// this file: localServiceUrl.js

export const KAYTEK_LOCAL_SERVICE_BASE_URL =
  (window?.__KAYTEK_LOCAL_SERVICE_URL__) || "http://127.0.0.1:8877"
